import React from 'react'

export default function Banner() {
  return (
    <section
  className="banner-area-2 pt-145"
  style={{ backgroundImage: "url(img/banner/about-bg.png)" }}
>
  <div className="container">
    <div className="row align-items-center pt-130 pb-140">
      <div className="col-xl-6 col-lg-8">
        <div className="banner-content py-5">
          <div className="section-title text-start">
            <span className="short-title wow fadeInUp">ABOUT US</span>
            <h1 className="wow fadeInUp mb-0" data-wow-delay="0.2s">
              Believing, banking and achieving different
            </h1>
          </div>
          {/* <a
            className="theme-btn-2 theme-btn-primary mt-45 wow fadeInUp"
            data-wow-delay="0.4s"
            href="#"
          >
            <span className="arrow">
              <span className="horizontal-line" />
            </span>
            View our 2019 Annual Report
          </a> */}
        </div>
      </div>
    </div>
  </div>
</section>

  )
}
